import { authHeader } from '../helpers/authHeader';
import { handleAxiosResponse, api_base_url, axiosInstance } from '../services/common.services';
import { handleServiceRequest } from '../services/handleServiceRequest';
import NotificationService from './NotificationService';
import {forEach} from 'react-bootstrap/ElementChildren';
import {CustomerSearchType} from "../components/customer-management/CustomerSearchForm";
import notificationService from "./NotificationService";
import {IgnoreError} from "../shared/sharedFunctions";

export const customerService = {
    searchCustomers,
    getCustomerById,
    getCustomerJobsByCustomerId,
    getBase64ImageByCustomerId,
    getMapArea,
    getTrucksByJobId,
    saveTruck,
    deleteTruck,
    createNewJob,
    saveCustomer,
    createNewCustomer,
    saveJob,
    sendInvoiceEmail,
    getCustomerJobByJobId,
    saveMapBase64ByCustomerId(customerId, base64String: string) {
        const object = {
            url: `${baseUrl}/${customerId}/map-image`,
            customErrorMessage: `Failed to save map image`,
            postBody: {
                imageDataBase64: base64String,
                customHandleError: IgnoreError
            }
        };
        return handleServiceRequest.put(object);
    },
    saveMapAreaByCustomerId(customerId, polygonPath) {
        const path = polygonPath.map(node => ({
            Lat:  node.lat,
            Long: node.lng
        }))
        const object = {
            url: `${baseUrl}/${customerId}/map-area`,
            customErrorMessage: `Failed to save map polygon`,
            postBody: {
                vertices: path,
            }
        };
        return handleServiceRequest.put(object);
    },
    SendMessaging(searchTerms, postObject) {
        const customer = searchTerms.customer;
        const job = searchTerms.job;
        const property = searchTerms.property;
        const searchModel = {
            firstName: customer?.firstName ?? null,
            lastName: customer?.lastName ?? null,
            email: customer?.email ?? null,
            phone: customer?.phone ?? null,
            customerStatusId: customer?.customerStatusId ?? null,
            customerNumber: customer?.customerId ?? null,
            webId: customer?.webId ?? null,
            linkCode: customer?.link ?? null,
            streetNumber: property?.streetNumber ?? null,
            streetPrefix: property?.prefix ?? null,
            streetName: property?.streetName ?? null,
            streetSuffix: property?.suffix ?? null,
            streetPostDirection: null ?? null,
            city: property?.city ?? null,
            state: property?.state ?? null,
            postalCode: null ?? null,
            county: null ?? null,
            propertyType: property?.propertyType ?? null,
            businessName: property?.businessName ?? null,
            dateEstimated: job?.dateEstimated ?? null,
            dateDone: job?.dateDone ?? null,
            transactionNumber: job?.transactionNumber ?? null,
            transactionDate: job?.transactionDate ?? null,
            depositSlip: job?.depositSlip ?? null,
            depositSlipDate: job?.depositDate ?? null
        }
        const postDataSMS = {
            customerSearchFilter: searchModel,
            messageText: postObject.textMessage,
        }
        const postDataEmail = {
            customerSearchFilter: searchModel,
            fromName: 'DONOTREPLY@barrecablacktop.com',
            subject: postObject.emailSubject,
            body: postObject.emailHTML,
        }
        const calls: Promise<any>[] = [];
        if(postObject.sendSMSMessage && postObject.textMessage != ''){
            calls.push(
                handleServiceRequest.post({
                    url: `/api/messages/sms`,
                    postBody: postDataSMS,
                    customErrorMessage: `Failed to send sms`,
                })
            );
        }
        if(postObject.sendEmail && postObject.sendEmail != ''){
            calls.push(
                handleServiceRequest.post({
                    url: `/api/messages/email`,
                    postBody: postDataEmail,
                    customErrorMessage: `Failed to send email`,
                })
            );
        }
        if (calls.length === 0) {
            notificationService.error('Must choose at least one Send Method (email or sms)')
            return Promise.resolve(null);
        }

        if (calls.length === 1) {
            return calls[0];
        } else {
            return Promise.all(calls);
        }
    },
    ExportCustomers(searchTerms) {
        const customer = searchTerms.customer;
        const job = searchTerms.job;
        const property = searchTerms.property;
        const searchModel = {
            firstName: customer?.firstName ?? null,
            lastName: customer?.lastName ?? null,
            email: customer?.email ?? null,
            phone: customer?.phone ?? null,
            customerStatusId: customer?.customerStatusId ?? null,
            customerNumber: customer?.customerId ?? null,
            webId: customer?.webId ?? null,
            linkCode: customer?.link ?? null,
            streetNumber: property?.streetNumber ?? null,
            streetPrefix: property?.prefix ?? null,
            streetName: property?.streetName ?? null,
            streetSuffix: property?.suffix ?? null,
            streetPostDirection: null ?? null,
            city: property?.city ?? null,
            state: property?.state ?? null,
            postalCode: null ?? null,
            county: null ?? null,
            propertyType: property?.propertyType ?? null,
            businessName: property?.businessName ?? null,
            dateEstimated: job?.dateEstimated ?? null,
            dateDone: job?.dateDone ?? null,
            transactionNumber: job?.transactionNumber ?? null,
            transactionDate: job?.transactionDate ?? null,
            depositSlip: job?.depositSlip ?? null,
            depositSlipDate: job?.depositDate ?? null
        }
        const object = {
            url: `${baseUrl}/export/csv`,
            customErrorMessage: `Failed to export customers`,
            postBody: {searchFilter: searchModel}
        };
        return handleServiceRequest.post(object);
    },
    getLinkedAddresses(linkCode: any) {
        const object = {
            url: `${baseUrl}/linked/${linkCode}`,
            customErrorMessage: `Failed to get linked addresses`,
        };
        return handleServiceRequest.get(object);
    },
    updateBillingInfo(billingPostObj: any) {
        const object = {
            url: `${baseUrl}/linked/billing`,
            postBody: billingPostObj,
            customErrorMessage: `Failed to update billing info`,
        };
        return handleServiceRequest.post(object);
    },
    getAvailableJobDates(customerId, jobId) {
        const object = {
            url: `${baseUrl}/${customerId}/jobs/${jobId}/available-dates`,
            customHandleError: IgnoreError,
        };
        return handleServiceRequest.get(object);
    }
};
const baseUrl = `/api/customers`;

function searchCustomers(searchTerms: CustomerSearchType, pageNum: number, PAGE_SIZE: number): Promise<any> {
    const customer = searchTerms.customer;
    const job = searchTerms.job;
    const property = searchTerms.property;
    const model = {
        startingPage: pageNum,
        count: PAGE_SIZE,
        searchFilter: {
            firstName: customer?.firstName ?? null,
            lastName: customer?.lastName ?? null,
            email: customer?.email ?? null,
            phone: customer?.phone ?? null,
            customerStatusId: customer?.customerStatusId ?? null,
            jobStatusId: job?.jobStatusId ?? null,
            customerNumber: customer?.customerId ?? null,
            webId: customer?.webId ?? null,
            linkCode: customer?.link ?? null,
            streetNumber: property?.streetNumber ?? null,
            streetPrefix: property?.prefix ?? null,
            streetName: property?.streetName ?? null,
            streetSuffix: property?.suffix ?? null,
            streetPostDirection: null ?? null,
            city: property?.city ?? null,
            state: property?.state ?? null,
            postalCode: property?.postalCode ?? null,
            county: null ?? null,
            propertyType: property?.propertyType ?? null,
            businessName: property?.businessName ?? null,
            dateEstimated: job?.dateEstimated ?? null,
            dateDone: job?.dateDone ?? null,
            transactionNumber: job?.transactionNumber ?? null,
            transactionDate: job?.transactionDate ?? null,
            depositSlip: job?.depositSlip ?? null,
            depositSlipDate: job?.depositDate ?? null
        }
        
    }
    const object = {
        url: `${baseUrl}/search`,
        customErrorMessage: `Failed to search`,
        postBody: model,
    };
    return handleServiceRequest.post(object);
}

function saveCustomer(data: any) {
    const object = {
        url: `${baseUrl}/${data.customerId}`,
        postBody: data,
        customErrorMessage: `Failed to save customer`,
    };
    return handleServiceRequest.put(object);
}

function createNewCustomer(data: any) {
    const object = {
        url: `${baseUrl}`,
        postBody: data,
        customErrorMessage: `Failed to create customer`,
    };
    return handleServiceRequest.post(object);
}


function getCustomerById(customerId: number): Promise<any> {
    const object = {
        url: `${baseUrl}/${customerId}`,
        customErrorMessage: `Failed to get customer`,
    };
    return handleServiceRequest.get(object);
}

function getMapArea(customerId: number): Promise<any> {
    const object = {
        url: `${baseUrl}/${customerId}/map-area`,
        customErrorMessage: `Failed to get map area`,
    };
    return handleServiceRequest.get(object);
}

function getBase64ImageByCustomerId(customerId: number): Promise<any> {
    const object = {
        url: `${baseUrl}/${customerId}/map-image`,
        customHandleError: IgnoreError
    };
    return handleServiceRequest.get(object);
}


function getCustomerJobsByCustomerId(customerId: number): Promise<any> {
    const object = {
        url: `${baseUrl}/${customerId}/jobs`,
        customErrorMessage: `Failed to get customer jobs`,
    };
    return handleServiceRequest.get(object);
}

function saveTruck(customerId: number, jobId: number, data): Promise<any> {
    if(data.jobTruckId){
        const editTruck = {
            jobTruckId: data.jobTruckId,
            truckNumber: data.truckNumber,
            arrivalTimeWindowId: data.arrivalTimeWindowId,
            arrivalDateAndTime: data.arrivalDateAndTime
        }
        const object = {
            url: `${baseUrl}/${customerId}/jobs/${jobId}/trucks/${data.jobTruckId}`,
            postBody: editTruck,
            customErrorMessage: `Failed to save truck`,
        };
        return handleServiceRequest.put(object);
    } else {
        const createTruck = {
            truckNumber: data.truckNumber,
            arrivalTimeWindowId: data.arrivalTimeWindowId,
            arrivalDateAndTime: data.arrivalDateAndTime
        }
        const object = {
            url: `${baseUrl}/${customerId}/jobs/${jobId}/trucks`,
            postBody: createTruck,
            customErrorMessage: `Failed to create truck`,
        };
        return handleServiceRequest.post(object);
    }
}

function deleteTruck(customerId: number, jobId: number, data): Promise<any> {
    const object = {
        url: `${baseUrl}/${customerId}/jobs/${jobId}/trucks/${data.jobTruckId}`,
        customErrorMessage: `Failed to delete truck`,
    };
    return handleServiceRequest.deleteItem(object);
}

function getTrucksByJobId(customerId: number, jobId: number): Promise<any> {
    const object = {
        url: `${baseUrl}/${customerId}/jobs/${jobId}/trucks`,
        customErrorMessage: `Failed to get trucks for job ${jobId}`,
    };
    return handleServiceRequest.get(object);
}

function createNewJob(customerId: number, year: number): Promise<any> {
    const postObject = 
    {
        businessYear: year,
        dateDone: null,
        orderTakenBy: null,
        scheduledViaWeb: true,
        officeComments: null,
        TruckComments: null,
        webComments: null,
        jobStatusId: 1,
        jobStatusName: null,
        jobSquareFeet: null,
        customerProvidedSquareFeet: null,
        pricedAsOfDate: null,
        totalJobPrice: 0,
        whenPriceApproved: null,
        sealcoatingPrice: 0,
        webPriceAdjustmentAmount: 0,
        autoAdjustmentsAmount: 0,
        patchworkPrice: 0,
        hotPatchworkPrice: 0,
        sawCutPrice: 0,
        stripingPrice: 0,
        crackSealPrice: 0,
        hotCrackSealPrice: 0,
        manualAdjustmentAmount: 0,
        payments: [],
        totalAmountReceived: 0,
        serviceTime: null,
        serviceStart: null,
        serviceEnd: null
    }
    const object = {
        url: `${baseUrl}/${customerId}/jobs`,
        customErrorMessage: `Failed to create job`,
        postBody: postObject
    };
    return handleServiceRequest.post(object);
}

function sendInvoiceEmail(customerId: number, jobId: number, recipientEmailOverwrite?: string): Promise<any> {
    const postObject =
        {
            recipientEmail: recipientEmailOverwrite
        }
    const object = {
        url: `${baseUrl}/${customerId}/jobs/${jobId}/invoice-email`,
        customErrorMessage: `Failed to send invoice`,
        postBody: postObject
    };
    return handleServiceRequest.post(object);
}

function saveJob(customerId: number, data: any) {
    if(data.dateDone === "")
        data.dateDone = null;
    if(data.dateDone != null) {
        if (data.dateDone instanceof Date) {
            data.dateDone = data.dateDone.toISOString().split('T')[0];
        }
    }
        
    const object = {
        url: `${baseUrl}/${customerId}/jobs/${data.jobId}`,
        postBody: data,
        customErrorMessage: `Failed to save job`,
    };
    return handleServiceRequest.put(object);
}

function getCustomerJobByJobId(customerId: number, jobId: any) {
    const object = {
        url: `${baseUrl}/${customerId}/jobs/${jobId}`,
        customErrorMessage: `Failed to get job data`,
    };
    return handleServiceRequest.get(object);
}